{
    "$schema": "https://raw.githubusercontent.com/jsonresume/resume-schema/v1.0.0/schema.json",
    "basics": {
        "name": "Jose Vicente Orts Romero",
        "label": "Ingeniero Informático",
        "image": "",
        "email": "jvortsromero@gmail.com",
        "phone": "",
        "url": "https://app.josrom.io/",
        "summary": "Desarrollador web con una extensa experiencia en el diseño, desarrollo y despliegue de aplicaciones web. Me considero una persona activa, que se adapta rápido a cualquier situación dentro del ámbito de la resolución de problemas. En mi tiempo libre me gusta aprender nuevos lenguajes de manera autodidacta, para mantenerme actualizado a las tecnologías actuales.",
        "location": {
            "countryCode": "ES",
            "city": "Alicante",
            "region": "Comunidad Valenciana"
        },
        "profiles": [
            {
                "network": "LinkedIn",
                "username": "jose-vicente-orts-romero-93aa9990",
                "url": "https://www.linkedin.com/in/jose-vicente-orts-romero-93aa9990/"
            },
            {
                "network": "GitHub",
                "username": "JoseVte",
                "url": "https://github.com/JoseVte"
            }
        ]
    },
    "work": [
        {
            "name": "Square1",
            "position": "Programador full stack senior",
            "startDate": "2023-05-01",
            "endDate": "2026-09-30",
            "summary": "Backend: PHP 7.0 a 8.0 con Laravel y WordPress. Frontend: Vue y Tailwind.",
            "highlights": [
                "Diseño y mantenimiento de APIs",
                "Desarrollo de nuevas funcionalidades en aplicaciones web en Laravel",
                "Desarrollo de nuevas funcionalidades y plugins para WordPress",
                "Mantenimiento y migración de versiones"
            ],
            "url": "https://www.linkedin.com/company/square1-ltd/",
            "location": "Alicante, Comunidad Valenciana, España"
        },
        {
            "name": "Square1",
            "position": "Programador full stack mid",
            "startDate": "2019-01-01",
            "endDate": "2023-04-30",
            "summary": "Backend: PHP 5.6 a 8.0 con Laravel y WordPress. Frontend: Vue, Tailwind y Bootstrap 3 a 4.",
            "highlights": [
                "Diseño y mantenimiento de APIs",
                "Desarrollo de nuevas funcionalidades en aplicaciones web en Laravel",
                "Desarrollo de nuevas funcionalidades y plugins para WordPress",
                "Mantenimiento y migración de versiones"
            ],
            "url": "https://www.linkedin.com/company/square1-ltd/",
            "location": "Alicante, Comunidad Valenciana, España"
        },
        {
            "name": "Square1",
            "position": "Programador full stack júnior",
            "startDate": "2016-01-31",
            "endDate": "2018-12-31",
            "summary": "Backend: PHP 5.6 a 7.0 con Laravel y WordPress. Frontend: JavaScript y Bootstrap 3 a 4.",
            "highlights": [
                "Diseño y mantenimiento de APIs",
                "Desarrollo de nuevas funcionalidades en aplicaciones web en Laravel",
                "Desarrollo de nuevas funcionalidades y plugins para WordPress",
                "Mantenimiento y migración de versiones"
            ],
            "url": "https://www.linkedin.com/company/square1-ltd/",
            "location": "Alicante, Comunidad Valenciana, España"
        },
        {
            "name": "Square1",
            "position": "Becario",
            "startDate": "2015-08-31",
            "endDate": "2015-12-31",
            "highlights": [],
            "url": "https://www.linkedin.com/company/square1-ltd/",
            "location": "Alicante, Comunidad Valenciana, España"
        }
    ],
    "volunteer": [],
    "education": [
        {
            "institution": "Universitat d'Alacant",
            "area": "Ingeniería Informática",
            "studyType": "Grado",
            "startDate": "2011-12-31",
            "endDate": "2016-12-31",
            "score": "",
            "courses": []
        }
    ],
    "awards": [],
    "certificates": [
        {
            "name": "Stripe Certified Professional Developer",
            "issuer": "Stripe",
            "endDate": "2025-05-31",
            "startDate": "2023-05-31",
            "url": "https://stripecertifications.credential.net/78b6d35c-3aa6-4622-8548-e83e90420b14"
        }
    ],
    "publications": [],
    "skills": [
        {
            "name": "PHP",
            "level": "10 años",
            "keywords": []
        },
        {
            "name": "JavaScript",
            "level": "10 años",
            "keywords": []
        },
        {
            "name": "CSS",
            "level": "10 años",
            "keywords": []
        },
        {
            "name": "HTML",
            "level": "10 años",
            "keywords": []
        },
        {
            "name": "MySQL",
            "level": "10 años",
            "keywords": []
        },
        {
            "name": "Java",
            "level": "Autodidacta",
            "keywords": []
        },
        {
            "name": "Laravel",
            "level": "10 años",
            "keywords": []
        },
        {
            "name": "WordPress",
            "level": "10 años",
            "keywords": []
        },
        {
            "name": "TailwindCSS",
            "level": "5 años",
            "keywords": []
        },
        {
            "name": "Bootstrap",
            "level": "5 años",
            "keywords": []
        },
        {
            "name": "Vue",
            "level": "5 años",
            "keywords": []
        },
        {
            "name": "React",
            "level": "Autodidacta",
            "keywords": []
        },
        {
            "name": "Git",
            "level": "10 años",
            "keywords": []
        },
        {
            "name": "Servidores Linux",
            "level": "10 años",
            "keywords": []
        },
        {
            "name": "Docker",
            "level": "5 años",
            "keywords": []
        }
    ],
    "languages": [
        {
            "language": "Castellano",
            "fluency": "Nativo"
        },
        {
            "language": "Valenciano",
            "fluency": "Nativo"
        },
        {
            "language": "Inglés",
            "fluency": "B2"
        }
    ],
    "interests": [],
    "references": [],
    "projects": [],
    "meta": {
        "version": "v1.0.0",
        "canonical": "https://github.com/jsonresume/resume-schema/blob/v1.0.0/schema.json"
    }
}
